import { render } from "./DataTable.vue?vue&type=template&id=1a894512&scoped=true&ts=true"
import script from "./DataTable.vue?vue&type=script&lang=ts"
export * from "./DataTable.vue?vue&type=script&lang=ts"

import "./DataTable.vue?vue&type=style&index=0&id=1a894512&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a894512"]])

export default __exports__